"use client";

import { motion, Variants } from "framer-motion";
import { cn } from "@/lib/utils";

interface WordFadeInProps {
  words: string;
  className?: string;
  delay?: number;
  variants?: Variants;
}

function WordFadeIn({
  words,
  delay = 0.15,
  variants = {
    hidden: { opacity: 0 },
    visible: (i: number) => ({
      y: 0,
      opacity: 1,
      transition: { delay: i * delay },
    }),
  },
  className,
}: WordFadeInProps) {
  const lines = words.split("\n");

  let wordIndex = 0;

  return (
    <motion.h1
      variants={variants}
      initial="hidden"
      animate="visible"
      className={cn(
        "font-display text-center text-4xl font-bold tracking-[-0.02em] drop-shadow-sm md:text-7xl md:leading-[5rem]",
        className,
      )}
    >
      {lines.map((line, lineIdx) => {
        const lineWords = line.split(" ");
        return (
          <span key={lineIdx}>
            {lineIdx > 0 && <br />}
            {lineWords.map((word) => {
              const i = wordIndex++;
              return (
                <motion.span key={`${word}-${i}`} variants={variants} custom={i}>
                  {word}{" "}
                </motion.span>
              );
            })}
          </span>
        );
      })}
    </motion.h1>
  );
}

export { WordFadeIn };
